export const COLORS = {
  primary: "#2782ce",
  primaryDark: "#1976d2",
  secondary: "#4384b4",
  secondaryText: "#6984b9",
  accentGreen: "#70b603",
  
  textPrimary: "#333333",
  textSecondary: "#666666",
  textGrey: "#626262",
  textLightGrey: "#999999",
  textDarkGrey: "#555555",
  textIcon: "#777777",
  textBlack: "#000000",
  textWhite: "#ffffff",
  textRed: "red",

  bgWhite: "#ffffff",
  bgLight: "#f2f2f2",
  bgLighter: "#f5f5f5",
  bgHover: "#f8f9fa",
  bgHeader: "#d7d7d7",
  bgSubHeader: "#eeeeee",
  bgToolbar: "#f2f2f2",
  
  border: "#cccccc",
  borderLight: "#e0e0e0",
  borderMedium: "#d7d7d7",
  borderDark: "#c4c4c4",
  borderTable: "#d9d9d9",
  borderTableContainer: "#d5d5d5",
  borderFaint: "#f0f0f0",
  
  iconGrey: "#757575",
  iconDarkGrey: "#616161",
  iconLight: "rgba(0, 0, 0, 0.54)",
  
  loader: "blue"
};
